import { useMemo } from 'react';

import { UnusedCertificate } from '@store/api/types';
import { useGetUnusedCertificatesQuery } from '@store/api/applications.api';

interface UseUnusedCertificatesResult {
  bought: UnusedCertificate[];

  returned: UnusedCertificate[];
}

interface UseUnusedCertificatesOptions {
  shopName?: string;
}

function applyCertificatesOptions(certificates: UnusedCertificate[], options: UseUnusedCertificatesOptions) {
  const { shopName } = options;

  let result = certificates;
  if (shopName) {
    result = result.filter((certificate) => certificate.provider === shopName);
  }

  return result;
}

export function useUnusedCertificates(options: UseUnusedCertificatesOptions = {}): UseUnusedCertificatesResult {
  const { data: unusedCertificates } = useGetUnusedCertificatesQuery();

  return useMemo(() => {
    if (!unusedCertificates) {
      return { bought: [], returned: [] };
    }

    const bought = applyCertificatesOptions(unusedCertificates.bought, options);
    const returned = applyCertificatesOptions(unusedCertificates.returned, options);

    return { bought, returned };
  }, [unusedCertificates, options]);
}
